module.exports = __webpack_public_path__ + "static/media/Logo.202bfe35.png";